module.exports = __webpack_public_path__ + "img/xk_2.3d260379.png";